import { parseCompatLevel } from '@/utils/compatMode'

/** L0–L2 在 /compat 专页测试；首页从 L3 起 */
export default defineNuxtRouteMiddleware((to) => {
  const level = parseCompatLevel(to.query.compat as string)
  if (level == null || level > 2) return

  const isCompatPage = to.path.endsWith('/compat') || to.path === '/compat'
  if (isCompatPage) return

  const prefix = to.path.includes('/en-US') ? '/en-US' : '/zh-CN'
  return navigateTo({
    path: `${prefix}/compat`,
    query: { ...to.query, compat: String(level) },
  })
})
